import { Button } from '@mui/material';

async function showLocalDemoNotification() {
  if (!('Notification' in window)) {
    alert('Ваш браузер не поддерживает уведомления');
    return;
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    alert('Вы не разрешили показывать уведомления в браузере');
    return;
  }

  new Notification('Напоминание от SaveToRich', {
    body: 'Не забудьте добавить доходы и расходы за сегодня 💰',
    icon: '/icons/icon-192.png',
  });
}

export const NotificationPreviewButton = () => {
  return (
    <Button className="text" onClick={showLocalDemoNotification}>
      Посмотреть пример уведомления
    </Button>
  );
};
